module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topbar"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_vm._v("\n    Resumer\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [(_vm.logined) ? _c('div', {
    staticClass: "userActions"
  }, [_c('span', {
    staticClass: "welcome"
  }, [_vm._v("您好，" + _vm._s(_vm.user.username))]), _vm._v(" "), _c('a', {
    staticClass: "button is-info is-outlined",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.signOut.apply(null, arguments)
      }
    }
  }, [_vm._v("登出")])]) : _c('div', {
    staticClass: "userActions"
  }, [_c('a', {
    staticClass: "button is-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signUpDialogVisible = true
      }
    }
  }, [_vm._v("注册")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signInDialogVisible = true
      }
    }
  }, [_vm._v("登录")])]), _vm._v(" "), _c('div', {
    staticClass: "userActions"
  }, [_c('a', {
    staticClass: "button is-primary is-outlined"
  }, [_vm._v("保存")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.preview
    }
  }, [_vm._v("预览")])])]), _vm._v(" "), _c('MyDialog', {
    attrs: {
      "title": "注册",
      "visible": _vm.signUpDialogVisible
    },
    on: {
      "close": function($event) {
        _vm.signUpDialogVisible = false
      }
    }
  }, [_c('SignUpForm', {
    on: {
      "success": function($event) {
        return _vm.signIn($event)
      },
      "cancel": _vm.cancel
    }
  })], 1), _vm._v(" "), _c('MyDialog', {
    attrs: {
      "title": "登录",
      "visible": _vm.signInDialogVisible
    },
    on: {
      "close": function($event) {
        _vm.signInDialogVisible = false
      }
    }
  }, [_c('SignInForm', {
    on: {
      "success": function($event) {
        return _vm.signIn($event)
      },
      "cancel": _vm.cancel
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a1383c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Topbar.vue
// module id = 187
// module chunks = 1